export default __webpack_public_path__ + "media/images/logo/contest/nikkei_social_business-8b0328cc842a292ad273a708223a4a48.jpg";